module.exports = __webpack_public_path__ + "img/dr_brodsky_headshot.b5e6d0d7.png";